import { render, staticRenderFns } from "./Archived.vue?vue&type=template&id=f45d91c8&scoped=true&"
import script from "./Archived.vue?vue&type=script&lang=js&"
export * from "./Archived.vue?vue&type=script&lang=js&"
import style0 from "./Archived.vue?vue&type=style&index=0&id=f45d91c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45d91c8",
  null
  
)

export default component.exports